define('helper-url-getParam',['exports'], function (exports) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    exports.default = function (param, str) {
        var regexS, regex, results;

        str = typeof str === 'string' && str ? str : window && window.location ? window.location.search : '';

        if (!param || !str) {
            return '';
        }

        param = param.replace(/[[]/, '').replace(/[\]]/, '');
        regexS = '[\\?&]' + param + '=([^&#]*)';
        regex = new RegExp(regexS, 'i');
        results = regex.exec(str);

        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    };
});
